<script setup lang="ts">
import type { IconProps } from '/#/components/base/icon/icon'
import type { TabProps } from '/#/components/base/tabs'
import type { ComputedRef } from 'vue'

import { mergeIconProps } from '/@/utils/helper'

const props = withDefaults(defineProps<TabProps>(), {
  icon: undefined,
  label: undefined,
  isActive: undefined,
})

const iconProps: ComputedRef<IconProps | undefined> = computed(() => {
  const defaultIconProps: Partial<IconProps> = {
    size: 'sm',
    color: 'inherit',
  }

  return mergeIconProps(defaultIconProps, props.icon)
})
</script>

<template>
  <div v-tippy="tooltip" class="tab-item-wrapper">
    <div class="tab-item">
      <div class="item-content" :class="{ 'is-active': isActive }">
        <div v-if="iconProps" class="tab-icon">
          <Icon v-bind="iconProps" />
        </div>
        <div class="tab-item-title">
          {{ label }}
        </div>
        <div v-if="badge" class="tab-countered">
          <Badge
            :class="isActive ? 'active' : 'passive'"
            rounded
            :label="badge"
            size="xxs"
          />
        </div>
      </div>
      <div v-if="isActive" class="bottom-border" />
    </div>
  </div>
</template>
